import { render, staticRenderFns } from "./FiltroPesquisaSPI.vue?vue&type=template&id=21629038&scoped=true"
import script from "./FiltroPesquisaSPI.vue?vue&type=script&lang=js"
export * from "./FiltroPesquisaSPI.vue?vue&type=script&lang=js"
import style0 from "./FiltroPesquisaSPI.vue?vue&type=style&index=0&id=21629038&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21629038",
  null
  
)

export default component.exports